
export const reviewsData: Record<number, Review[]> = {
  1: [
    {
      id: 1,
      userId: 'user_1',
      userName: 'Sarah Mitchell',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20brown%20hair%2C%20friendly%20smile%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar1&orientation=squarish',
      rating: 5,
      title: 'Best tablet I have ever owned',
      comment: 'The M2 chip makes everything incredibly fast. The display is stunning for creative work, and the battery easily lasts all day. Worth every penny!',
      date: '2024-06-15',
      helpful: 124,
      verified: true,
      images: [],
    },
    {
      id: 2,
      userId: 'user_2',
      userName: 'James Chen',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20Asian%20man%20in%20his%2030s%2C%20confident%20expression%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar2&orientation=squarish',
      rating: 4,
      title: 'Great for productivity',
      comment: 'Amazing device for work. The only downside is the price, but if you can afford it, it is definitely worth the investment. Stage Manager is a game changer.',
      date: '2024-06-10',
      helpful: 89,
      verified: true,
      images: [],
    },
    {
      id: 3,
      userId: 'user_3',
      userName: 'Emily Rodriguez',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Hispanic%20woman%20with%20long%20dark%20hair%2C%20warm%20smile%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar3&orientation=squarish',
      rating: 5,
      title: 'Perfect for digital art',
      comment: 'As a digital artist, this iPad Pro has transformed my workflow. The Apple Pencil responsiveness is incredible, and ProCreate runs flawlessly.',
      date: '2024-06-05',
      helpful: 156,
      verified: true,
      images: [
        'https://readdy.ai/api/search-image?query=Digital%20artwork%20created%20on%20iPad%20showing%20colorful%20illustration%2C%20creative%20tablet%20art%20example&width=200&height=200&seq=review1img1&orientation=squarish',
      ],
    },
    {
      id: 4,
      userId: 'user_4',
      userName: 'Michael Thompson',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20man%20with%20glasses%2C%20professional%20appearance%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar4&orientation=squarish',
      rating: 3,
      title: 'Good but expensive',
      comment: 'The tablet itself is excellent, but I feel like Apple is charging too much for what you get. The base storage should be higher at this price point.',
      date: '2024-05-28',
      helpful: 67,
      verified: false,
      images: [],
    },
  ],
  2: [
    {
      id: 5,
      userId: 'user_5',
      userName: 'Amanda Foster',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20blonde%20woman%20in%20her%2020s%2C%20stylish%20appearance%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar5&orientation=squarish',
      rating: 5,
      title: 'Worth the splurge!',
      comment: 'My hair has never looked better. Dries so fast and leaves my hair smooth and shiny. The attachments are amazing for styling.',
      date: '2024-06-12',
      helpful: 203,
      verified: true,
      images: [],
    },
    {
      id: 6,
      userId: 'user_6',
      userName: 'Lisa Park',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Korean%20woman%20with%20short%20hair%2C%20elegant%20appearance%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar6&orientation=squarish',
      rating: 4,
      title: 'Game changer for thick hair',
      comment: 'Finally a dryer that can handle my thick hair without taking forever. The intelligent heat control really does protect from damage.',
      date: '2024-06-08',
      helpful: 145,
      verified: true,
      images: [],
    },
  ],
  3: [
    {
      id: 7,
      userId: 'user_7',
      userName: 'David Wilson',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20with%20beard%20in%20his%2030s%2C%20creative%20professional%20look%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar7&orientation=squarish',
      rating: 5,
      title: 'Professional quality images',
      comment: 'The autofocus is incredibly fast and accurate. Low light performance is outstanding. This camera has elevated my photography to the next level.',
      date: '2024-06-14',
      helpful: 178,
      verified: true,
      images: [
        'https://readdy.ai/api/search-image?query=Stunning%20landscape%20photograph%20taken%20with%20professional%20camera%2C%20golden%20hour%20lighting%2C%20sharp%20details&width=200&height=200&seq=review3img1&orientation=squarish',
      ],
    },
  ],
  5: [
    {
      id: 8,
      userId: 'user_8',
      userName: 'Chris Anderson',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20man%20with%20curly%20hair%2C%20casual%20tech%20professional%20look%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar8&orientation=squarish',
      rating: 5,
      title: 'Best iPhone yet',
      comment: 'The titanium design feels premium, the camera is insane, and the A17 Pro chip handles everything I throw at it. Battery life is solid too.',
      date: '2024-06-16',
      helpful: 234,
      verified: true,
      images: [],
    },
    {
      id: 9,
      userId: 'user_9',
      userName: 'Rachel Kim',
      userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20Asian%20woman%20with%20glasses%2C%20modern%20professional%20appearance%2C%20neutral%20background%2C%20high%20quality%20photography&width=100&height=100&seq=avatar9&orientation=squarish',
      rating: 4,
      title: 'Great upgrade from iPhone 13',
      comment: 'The 5x zoom is amazing for photography. Action button is more useful than I expected. Only wish it had longer battery life.',
      date: '2024-06-11',
      helpful: 112,
      verified: true,
      images: [],
    },
  ],
};

export interface Review {
  id: number;
  userId: string;
  userName: string;
  userAvatar: string;
  rating: number;
  title: string;
  comment: string;
  date: string;
  helpful: number;
  verified: boolean;
  images: string[];
}

export const getProductReviews = (productId: number): Review[] => {
  return reviewsData[productId] || [];
};

export const getAverageRating = (productId: number): number => {
  const reviews = reviewsData[productId];
  if (!reviews || reviews.length === 0) return 0;
  const sum = reviews.reduce((acc, review) => acc + review.rating, 0);
  return Math.round((sum / reviews.length) * 10) / 10;
};

export const getRatingDistribution = (productId: number): Record<number, number> => {
  const reviews = reviewsData[productId] || [];
  const distribution: Record<number, number> = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  reviews.forEach(review => {
    distribution[review.rating]++;
  });
  return distribution;
};
